import React from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { trpc } from "@editor/utils/trpc";

import EmptyState from "@replo/design-system/components/empty-state/EmptyState";
import { skipToken } from "@tanstack/react-query";
import { FolderSearch } from "lucide-react";

import PageTemplateCard, { PageTemplateCardSkeleton } from "./PageTemplateCard";

function PageTemplatesSection() {
  const projectId = useCurrentProjectId();

  const { data: projectPageTemplates, isLoading: isLoadingPageTemplates } =
    trpc.fileTemplate.find.useQuery(
      projectId
        ? {
            projectId,
            type: "page",
            options: { page: 0, pageSize: 15 },
          }
        : skipToken,
    );

  // TODO (Ben, 2025-07-30): For now we will need to have these global templates shown since we don't generate project templates yet.
  // However, once we do we should think about how we want to handle cases where there are no project templates.
  // option a: show global templates (maybe with a note that we are generating project templates)
  // option b: have some empty state with a note that we are generating project templates
  const { data: globalPageTemplates, isLoading: isLoadingGlobalPageTemplates } =
    trpc.fileTemplate.find.useQuery(
      projectId
        ? {
            projectId,
            type: "page",
            options: { page: 0, pageSize: 15, onlyGlobalTemplates: true },
          }
        : skipToken,
    );

  if (isLoadingPageTemplates || isLoadingGlobalPageTemplates) {
    return (
      <div className="grid grid-cols-4 gap-4 pb-6">
        {Array.from({ length: 6 }).map((_, index) => (
          <PageTemplateCardSkeleton key={index} />
        ))}
      </div>
    );
  }

  const displayedPageTemplates =
    projectPageTemplates && projectPageTemplates.length > 0
      ? projectPageTemplates
      : globalPageTemplates;

  return (
    <div className="flex gap-4 flex-col h-full">
      {displayedPageTemplates?.length === 0 ? (
        <EmptyState
          title="No templates found"
          description="Start building with Replo — we can't wait to bring your ideas to life!"
          icon={<FolderSearch className="icon-size-default" />}
          UNSAFE_className="py-[10%]"
        />
      ) : (
        <div className="grid grid-cols-4 gap-4 pb-6 overflow-y-auto">
          {displayedPageTemplates?.map((template) => (
            <PageTemplateCard
              key={template.id}
              template={template}
              isSelected={false}
              onClick={() => {}}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default PageTemplatesSection;
